import { render, staticRenderFns } from "./user-analytics.vue?vue&type=template&id=565142be"
import script from "./user-analytics.vue?vue&type=script&lang=js"
export * from "./user-analytics.vue?vue&type=script&lang=js"
import style0 from "./user-analytics.vue?vue&type=style&index=0&id=565142be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports